import * as React from "react";

const IconArrowLeft: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="currentColor"><polygon fill="currentColor" points="10.234 39.767 10.5 39.5 10.234 39.233 6.284 35.267 6.019 35 5.487 35.534 5.753 35.8 9.061 39.122 .376 39.122 0 39.122 0 39.878 .376 39.878 9.061 39.878 5.753 43.2 5.487 43.466 6.019 44 6.284 43.733 10.234 39.767"  transform="matrix(-1 0 0 1 10.5 -34.967)"/></svg>;
};

export default React.memo(IconArrowLeft);
